<app-common-announcement [announcementMessage]="announcementData"></app-common-announcement>
<nav class="navbar" [ngClass]="this.schoolProps.properties.job_only_school ? 'job-navbar' : ''">
  <div class="container-fluid display-profile-header pl-20 pr-20 align-items-center">
    <div class="d-flex">
      <!-- <i  class="bi bi-list"></i> -->
      <!-- <img alt=""  *ngIf="this.schoolProps.properties.job_only_school" class="logo-image" src="assets/images/side-nav/fav_img.png"> -->
      <img alt="" *ngIf="this.schoolProps.properties.job_only_school" class="side_logo_text d-show-350"
        src="assets/images/side-nav/CCJobsWhite.png" />
      <img alt="" *ngIf="this.schoolProps.properties.job_only_school" class="fav_logo d-none-350"
        src="assets/images/side-nav/fav_img.png" />
      <img alt="" *ngIf="!this.schoolProps.properties.job_only_school" class="side_logo_text_booking d-show-350"
        src="assets/images/favicon/CCLogo.png" (click)="navigateToBooking()" appFocus appClick />
      <img alt="" *ngIf="!this.schoolProps.properties.job_only_school" class="fav_logo d-none-350"
        src="assets/images/favicon/fav_icon_new.png" />
      <!-- <input type="text" placeholder="Search" class="form-control ml-20"> -->
    </div>
    <div class="nav-item list-unstyled d-flex align-items-center">
      <p class="nav-link ShowOnRes plan-badge" *ngIf="this.schoolProps.properties.job_only_school">
        {{ plan }}
      </p>
      <button data-canny-changelog class="mr-20" aria-label="Changelog" title="Changelog">
        <img src="assets/images/MEgaphone.png" alt="Changelog" width="30" height="30" />
      </button>

      <!-- <a routerLink="/school/feedback" aria-label="Feedback" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }" class="nav-link clr-cc-vilot text-regular-medium feedback-batch">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" fill="#3A0CA3" stroke="#3A0CA3
" stroke-width="1" class="bi bi-exclamation-square" viewBox="0 0 16 19">
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
          <path
            d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" />
        </svg> Feature requests
      </a> -->
      <li class="nav-item dropdown" *ngIf="hideHeader == false">
        <a class="nav-link dropdown-toggle px-0" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          <span class="mr-10">{{ schoolProps.mixpanel_data.school_name }}</span>
          <img width="42px" alt="i" class="school_avatar"
            [src]="
              schoolLogo == '' || schoolLogo == null || schoolLogo == undefined ? 'assets/images/pro_avatar.png' : schoolLogo" />
        </a>
        <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
          <!-- <li><a class="dropdown-item">{{this.schoolProps.mixpanel_data.school_name}}</a></li> -->
          <li *ngIf="this.schoolProps.properties.job_only_school  && !this.schoolProps.properties.is_booking_school">
            <a class="dropdown-item" routerLink="/school/school-profile" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">Profile</a>
          </li>
          <!-- <li><a class="dropdown-item">{{this.schoolProps.mixpanel_data.group_name}}</a></li> -->

          <li
            *ngIf="!this.schoolProps.properties.job_only_school && permissionService.hasPermission(PERMISSIONS.SCHOOL_PROFILE.VIEW)">
            <a class="dropdown-item" routerLink="/school/school-profile" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">School Profile</a>
          <li
            *ngIf="!this.schoolProps.properties.job_only_school && permissionService.hasPermission(PERMISSIONS.SCHOOL_PROFILE.VIEW)">
            <a class="dropdown-item" routerLink="/school/settings/my-settings" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">Profile Settings</a>
          </li>
          <li
            *ngIf="!this.schoolProps.properties.job_only_school && permissionService.hasPermission(PERMISSIONS.SCHOOL_PROFILE.VIEW)">
            <a class="dropdown-item" routerLink="/school/settings/admin-settings" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">Admin Settings</a>
          </li>
          <li
            *ngIf="this.schoolProps.properties.job_only_school && !this.schoolProps.properties.booking_school && permissionService.hasPermission(PERMISSIONS.MANAGE_TEAM.VIEW)">
            <a class="dropdown-item" routerLink="/school/manage-team" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">Manage Team</a>
          </li>
          <li
            *ngIf="!this.schoolProps.properties.job_only_school && this.schoolProps.properties.booking_school && permissionService.hasPermission(PERMISSIONS.MANAGE_TEAM.VIEW)">
            <a class="dropdown-item" routerLink="/school/manage-team" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">Manage Team</a>
          </li>
          <li *ngIf="this.schoolProps.properties.job_only_school && !this.schoolProps.properties.booking_school">
            <a class="dropdown-item" routerLink="/school/jobs/job-settings" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">My Settings</a>
          </li>
          <li *ngIf="this.schoolProps.properties.is_qld_school && this.schoolProps.properties.is_multiple_access && from_page_cookie != 'loginas_group'">
            <a class="dropdown-item" routerLink="/school/settings/my-schools" routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }">My Schools</a>
          </li>
          <li *ngIf="from_page_cookie == 'loginas'">
            <a class="dropdown-item" (click)="backToAdmin()">Back to admin</a>
          </li>
          <li *ngIf="from_page_cookie == 'loginas_coordinator'">
            <a class="dropdown-item" (click)="backToCoOrdinator()">Back to Coordinator</a>
          </li>
          <li *ngIf="from_page_cookie == 'loginas_group'">
            <a class="dropdown-item" (click)="backToFromCoGroup(this.schoolProps.properties.group_user_id)">Back to {{this.schoolProps.properties.is_qld_school ? 'Tracer' : 'Group'}}</a>
          </li>
          <li
            *ngIf="this.schoolProps.properties.group_user_id != '' && this.schoolProps.properties.group_user_id != null && this.schoolProps.properties.group_user_id != undefined">
            <a class="dropdown-item" (click)="backToFromCoGroup(this.schoolProps.properties.group_user_id)">Back to
              Group</a>
          </li>
          <!-- <li
            *ngIf="this.schoolProps.properties.back_to_current == true || this.schoolProps?.properties?.back_to_current">
            <button class="dropdown-item switch-back-button" type="button" (click)="switchBack()">Switch back to old
              ClassCover
            </button>
          </li> -->
          <!-- <ng-container *ngIf="shouldShowHeader()">
          <app-swich-back-to-python [jobOnly]="this.schoolProps.properties.job_only_school"
            fromComp="header_menu"></app-swich-back-to-python>
            </ng-container> -->
          <!-- <li><a class="dropdown-item">{{this.schoolProps.mixpanel_data.name}}</a></li> -->

          <li>
            <a class="dropdown-item" (click)="logout()">Logout</a>
          </li>
          <!-- <li><a class="dropdown-item">Switch to old ClassCover Website</a></li> -->
          <div class="HideOnRes">
            <li>
              <hr class="dropdown-divider" />
            </li>
            <li>
              <a class="dropdown-item">{{
                schoolProps.mixpanel_data.school_name
                }}</a>
            </li>
            <li>
              <a class="dropdown-item plan-badge">{{ plan }}</a>
            </li>
          </div>
        </ul>
      </li>
      <li class="nav-item dropdown" *ngIf="hideHeader == true">
        <a class="nav-link dropdown-toggle px-0" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          <span class="mr-10">{{ schoolProps.mixpanel_data.school_name }}</span>
          <img width="42px" alt="i" class="school_avatar"
            [src]="
              schoolLogo == '' || schoolLogo == null || schoolLogo == undefined ? 'assets/images/pro_avatar.png' : schoolLogo" />
        </a>
      </li>
    </div>

    <!-- <p class="nav-link HideOnRes plan-badge" *ngIf="this.schoolProps.properties.job_only_school">
            {{plan}}
        </p> -->
  </div>
</nav>